import React from "react";

export function WKingIcon({ color = "#3C3C3C" }: { color?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 125 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.5795 49.5433V36.1487H89.3606V19.4091H70.7087V4.69922H54.211V19.4129H35.5628V36.1562H52.3439V49.5471"
        fill="#F0F0F0"
      />
      <path
        d="M72.5795 49.5433V36.1487H89.3606V19.4091H70.7087V4.69922H54.211V19.4129H35.5628V36.1562H52.3439V49.5471"
        stroke={color}
        stroke-width="8"
        stroke-linecap="round"
      />
      <path
        d="M74.972 45.726H49.9893C47.0795 45.726 44.7206 48.084 44.7206 50.9927C44.7206 53.9015 47.0795 56.2595 49.9893 56.2595H74.972C77.8818 56.2595 80.2406 53.9015 80.2406 50.9927C80.2406 48.084 77.8818 45.726 74.972 45.726Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.1244 131.79C95.1244 131.79 124.514 81.4539 120.118 71.6347C115.719 61.823 88.068 54.6381 62.4882 54.6381C36.9083 54.6381 9.25731 61.8192 4.85794 71.6347C0.45857 81.4501 29.8482 131.79 29.8482 131.79H95.1244Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M62.4882 129.79C62.4882 129.79 27.9811 129.972 18.3017 135.913C11.7745 139.919 10.2324 149.708 11.1206 159.811H113.856C114.744 149.712 113.206 139.916 106.675 135.909C96.9991 129.975 62.4882 129.79 62.4882 129.79Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linejoin="round"
      />
    </svg>
  );
}
